import React from "react";
import clsx from "clsx";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {
  Grid,
  TextField,
  Button,
  CircularProgress,
  Divider,
  ListItemText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { EventEmitter } from "../events/EventEmitter";
import { ReportingService } from "../services/ReportingService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import history from "../utils/history";
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FilterListIcon from "@material-ui/icons/FilterList";
import emptyTrash from "../assets/images/empty_trash.png";
import moment from "moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { EmployeeService } from "../services/EmployeeService";
import {
  getMomentDate,
  getUniquMachineNumbers,
  getUniqueNames,
  getUniqueTypes,
  ROLES,
} from "../constants/constants";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import { ThemeProvider } from "@material-ui/core/styles";
import { defaultTheme } from "../utils/theme";
import { AuthConsumer } from "../routes/AuthContext";
import HasPermission from "../auth/HasPermission";
import { VisitorService } from "../services/VisitorService";
import { DataConvertAsync } from "../utils/DataConvertAsync";
import LoadingComponents from "../components/LoadingComponents";
import LHDLineGraphComponent from "../reporting/LHDLineGraphComponent";
import BarGraphComponentV2 from "../reporting/BarGraphComponentV2";
import { EquipmentsService } from "../services/EquipmentsService";
const drawerWidth = 260;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
    },
    rtl: { value: theme.direction },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "rgba(0,255,255, 0.8)",
      },
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    radio: {
      "&$checked": {
        color: "#f96500",
      },
    },
    checked: {},
    container: {
      width: "100%",
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    title: {
      flex: "1 1 100%",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    extendedIcon: {
      marginRight: 1,
    },
    table: {
      minWidth: 700,
    },
    underline: {
      "&&&:before": {
        borderBottom: "none",
      },
      "&&:after": {
        borderBottom: "none",
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  });

interface Props extends WithStyles<typeof styles> {
  profileData: any;
  onLogOut: any;
  properties: any;
  location?: any;
}
class GenericDashboard extends React.Component<Props> {
  state = {
    open: false,
    selectedMenuItem: "Screening Dashboard",
    companyId: "",
    company: { name: "" },
    isFiltering: false,
    isComparisonFiltering: false,
    employeeFiltered: { _id: "", fullName: "" },
    filterStartDate: new Date(),
    filterEndDate: new Date(),
    filterComparisonDate: new Date(),
    employees: Array<any>(),
    visitors: Array<any>(),
    employeeFilteredData: Array<any>(),
    filteredTableData: Array<any>(),
    isLoading: false,
    openGraphDetailsDialog: false,

    tabValue: 1,
    radioOEEValue: "",
    radioUtilityValue: "",
    radioPreuseValue: "",
    radioEffectivenessValue: "",

    checkedOEE: false,
    checkedQuality: false,
    checkedAvailability: true,
    checkedUtilisation: true,

    selectedOEEMachineItem: "",
    selectedUtilityMachineItem: "",
    selectedEquipment: "",
    selectedInspection: "",

    utilityShiftIsNotEmpty: false,
    OEEShiftIsNotEmpty: false,
    preuseShiftIsNotEmpty: false,
    effectivenssIsNotEmpty: false,

    genericData: Array<any>(),
    originalList: Array<any>(),

    SHIFT_DURATION: 0,

    mBarDataPartA: Array<any>(),
    mBarPreuseData: Array<any>(),
    mBarDataPartC: Array<any>(),
    mBarDataV2: Array<any>(),

    mMachineOEEData: Array<any>(),
    mMachineUtilityData: Array<any>(),

    mMachineEffectivenessData: Array<any>(),

    mBarDataLoading: false,

    equipments: Array<any>(),
    uniqueNames: Array<any>(),
    uniqueTypes: Array<any>(),
    uniqueMachineNumbers: Array<any>(),

    inspections: Array<any>(),
    uniqueInspectionNames: Array<any>(),
  };

  componentDidMount = () => {
    let startDate = moment(new Date()).subtract(7, "days").toDate();
    let endDate = moment(new Date()).toDate();
    this.setState(
      {
        filterStartDate: startDate,
        filterEndDate: endDate,
        isFiltering: true,
      },
      () => {
        this.getData();
      }
    );
  };
  componentWillMount = () => {};
  componentDidUpdate = (prevProps: any) => {
    if (prevProps.profileData.companyId !== this.props.profileData.companyId) {
      this.getData();
    }
  };

  getData = () => {
    let companyId =
      this.props.profileData && this.props.profileData.companyId
        ? this.props.profileData.companyId
        : this.props.location &&
          this.props.location.state &&
          this.props.location.state.companyData._id
        ? this.props.location.state.companyData._id
        : "";
    if (companyId) {
      this.setState(
        {
          companyId: companyId,
        },
        () => {
          this.getCompanyDetails();
          this.getEquipmentsByCompanyId(this.state.companyId);
        }
      );
    }
  };

  getEquipmentsByCompanyId = (companyId: String) => {
    let equipmentsService: EquipmentsService = new EquipmentsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    equipmentsService.getEquipmentByCompanyId(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.equipments) {
        let names = getUniqueNames(resp.equipments).map((obj: any) => {
          return {
            label: obj.title,
            value: obj.title.replace(" ", "-").toUpperCase(),
          };
        });
        this.setState(
          {
            equipments: resp.equipments,
            uniqueNames: names,
            selectedEquipment: names && names.length > 0 ? names[0].value : "",
            uniqueTypes: getUniqueTypes(resp.equipments),
            uniqueMachineNumbers: getUniquMachineNumbers(resp.equipments),
          },
          () => {
            this.getInspectionsByTypeCategoryAndEquipment();
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  getUniqueValues = (values: any) => {
    let uniqueValues = new Array<any>();
    values.map((obj: any) => {
      let mObjects = uniqueValues.filter((mObj: any) => {
        return mObj.name === obj.name;
      });
      if (mObjects.length === 0) {
        uniqueValues.push({ name: obj.name, value: obj._id });
      }
      return null;
    });
    return uniqueValues;
  };

  getInspectionsByTypeCategoryAndEquipment = () => {
    const { properties } = this.props;
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getInspectionsByTypeCategoryAndEquipment(
      this.state.companyId,
      properties.inspectionType.value,
      properties.category.value,
      this.state.selectedEquipment,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState({
              uniqueInspectionNames: this.getUniqueValues(resp.data),
              inspections: resp.data,
            });
          } else {
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {}
    );
  };

  getAlertData = () => {
    if (!this.state.companyId) {
      return;
    }
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getAlertsAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState({
              alertsData: resp.data,
            });
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {}
    );
  };
  getQuestionnaireReports = () => {
    if (!this.state.companyId) {
      return;
    }
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getQuestionnaireReportsByCompanyAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionnaireData: resp.data,
                originalList: resp.data,
              },
              () => {
                this.drawGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {}
    );
  };
  getQuestionnaireReportsBetweenTwoDates = () => {
    if (!this.state.companyId) {
      return;
    }
    var compareStartDate = moment(this.state.filterStartDate, "YYYY-MM-DD");
    var compareEndDate = moment(this.state.filterEndDate, "YYYY-MM-DD");
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getQuestionnaireReportsBetweenTwoDatesByCompanyAsync(
      this.state.companyId,
      compareStartDate,
      compareEndDate,
      this.state.employeeFiltered && this.state.employeeFiltered._id
        ? this.state.employeeFiltered._id
        : null,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionnaireData: resp.data,
              },
              () => {
                this.drawGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {}
    );
  };
  drawBarGraphs = () => {
    if (this.state.genericData && this.state.genericData.length > 0) {
      let dataConvertAsync: DataConvertAsync = new DataConvertAsync();
      dataConvertAsync
        .convertToGenericBarData(
          this.state.genericData,
          this.state.selectedEquipment
        )
        .then((resp: any) => {
          if (resp && resp.length > 0) {
            this.setState({
              mBarDataPartA: resp,
              preuseShiftIsNotEmpty: false,
            });
          } else {
            this.setState({
              mBarDataPartA: [],
              preuseShiftIsNotEmpty: true,
            });
          }
        });
    } else {
      this.setState({
        mBarDataPartA: [],
        preuseShiftIsNotEmpty: true,
      });
    }
  };

  drawGraphs = () => {};
  getVisitorsByCompany = () => {
    if (!this.state.companyId) {
      return;
    }
    let visitorService: VisitorService = new VisitorService();
    this.setState({
      isLoading: true,
    });

    visitorService.getVisitorsByCompanyIdAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.visitors) {
            this.setState({
              visitors: resp.visitors,
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => {}
    );
  };
  getEmployeesByCompany = () => {
    if (!this.state.companyId) {
      return;
    }
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isLoading: true,
    });

    employeeService.getEmployeesByCompanyIdAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.employees) {
            this.setState({
              employees: resp.employees,
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => {}
    );
  };

  getCompanyDetails = () => {
    if (!this.state.companyId) {
      return;
    }
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isLoading: true,
    });

    employeeService.getCompanyDetailsAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });

          if (resp && resp.success && resp.company) {
            let shiftDuration = this.getShiftsDuractionForCompany(resp.company);
            let defaultShift = this.getDefaultShift(resp.company);
            this.setState(
              {
                company: resp.company,
                SHIFT_DURATION: shiftDuration,
                radioOEEValue: defaultShift,
                radioUtilityValue: defaultShift,
                radioPreuseValue: defaultShift,
              },
              () => {
                this.getGenericReportingData();
                this.getEmployeesByCompany();
                this.getVisitorsByCompany();
              }
            );
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => {}
    );
  };

  getShiftsDuractionForCompany = (company: any) => {
    if (company.shifts && company.shifts.length > 0) {
      let shift = company.shifts[0];
      var startOfShift = moment(
        getMomentDate(
          `${new Date().toDateString()} ${shift.startOfShift}`,
          "DD MM YYYY HH:mm"
        )
      );
      var endOfShift = moment(
        getMomentDate(
          `${new Date().toDateString()} ${shift.endOfShift}`,
          "DD MM YYYY HH:mm"
        )
      );
      var duration = moment.duration(endOfShift.diff(startOfShift));
      var minutes = duration.asMinutes();
      return minutes;
    }
  };

  getDefaultShift = (company: any) => {
    let shiftValue = "";
    if (company.shifts && company.shifts.length > 0) {
      let shift = company.shifts[0];
      shiftValue = shift.label;
    }
    return shiftValue;
  };

  getShiftTitles = (company: any) => {
    let shiftsTitles = new Array<any>();
    if (company.shifts && company.shifts.length > 0) {
      company.shifts.map((shiftItem: any) => {
        shiftsTitles.push(shiftItem.label);
        return null;
      });
    }
    return shiftsTitles;
  };

  getGenericReportingData = () => {
    const { properties } = this.props;
    let reportingService: ReportingService = new ReportingService();
    reportingService.getGenericReportsByCompany(
      properties.inspectionType.value,
      properties.category.value,
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                genericData: resp.data,
                originalList: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {}
    );
  };

  dataNotAvailable = () => {
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          style={{ marginTop: 10, textAlign: "center" }}
        >
          {"Data available".toUpperCase()}
        </Typography>
      </div>
    );
  };
  renderPersonalisedGraph = () => {
    // data.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
  };
  redirect = () => {
    let paramObj = {
      profileData: this.props.profileData,
      companyId: this.state.companyId,
    };
    history.push({
      pathname: `/dashboard/details`,
      state: paramObj,
    });
  };
  handleClick = () => {
    this.redirect();
  };

  handleApplyFilter = () => {
    this.setState(
      {
        isFiltering: !this.state.isFiltering,
      },
      () => {
        if (!this.state.isFiltering) {
        } else {
          this.setState({
            isLoading: true,
          });
          this.requestDataForDateRange();
        }
      }
    );
  };
  handleApplyComparisonFilter = () => {
    this.setState(
      {
        isComparisonFiltering: !this.state.isComparisonFiltering,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  requestDataForDateRange = () => {
    const { properties } = this.props;
    var compareStartDate = moment(this.state.filterStartDate).format(
      "YYYY-MM-DD"
    );
    var compareEndDate = moment(this.state.filterEndDate).format("YYYY-MM-DD");
    let reportingService: ReportingService = new ReportingService();
    reportingService.getGenericReportsBetweenTwoDatesByCompanyAsync(
      this.state.companyId,
      properties.inspectionType.value,
      properties.category.value,
      compareStartDate,
      compareEndDate,
      this.state.employeeFiltered && this.state.employeeFiltered._id
        ? this.state.employeeFiltered._id
        : null,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                genericData: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {}
    );
  };

  handleFilterStartDateChange = (date: Date | null) => {
    if (!this.state.employeeFiltered || !this.state.employeeFiltered._id) {
      this.setState({
        filterStartDate: date,
        isFiltering: false,
      });
    } else {
      this.setState({
        filterStartDate: date,
        isFiltering: false,
      });
    }
  };
  handleFilterComparisonDateChange = (date: Date | null) => {
    this.setState(
      {
        filterComparisonDate: date,
        isComparisonFiltering: !this.state.isComparisonFiltering,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };
  handleFilterEndDateChange = (date: Date | null) => {
    if (!this.state.employeeFiltered || this.state.employeeFiltered._id) {
      this.setState({
        filterEndDate: date,
        isFiltering: false,
      });
    } else {
      this.setState({
        filterEndDate: date,
        isFiltering: false,
      });
    }
  };

  getEmployeeDetails = () => {
    let employeeDetails = this.state.employees.filter((employee: any) => {
      return employee.fullName === this.state.employeeFiltered.fullName;
    });
    if (employeeDetails && employeeDetails.length > 0) {
      return employeeDetails[0];
    } else {
      return null;
    }
  };

  handleOnTextChanged = (event: any) => {
    if (event && event.target && event.target.value) {
      let value = event.target.value;
      this.applyEmployeeFilter(value);
    }
  };

  applyEmployeeFilter = (person: any) => {
    const { properties } = this.props;
    let company: any = this.state.company;
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getGenericReportsByPerson(
      properties.inspectionType.value,
      properties.category.value,
      company._id,
      person._id,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp) {
            this.setState(
              {
                employeeFiltered: person,
                genericData: resp.data,
                employeeFilteredData: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => {}
    );
  };
  onToolBarButtonClicked = () => {
    if (this.props.onLogOut) {
      this.props.onLogOut();
    }
    history.push({
      pathname: `/login`,
      state: {},
    });
  };

  openAddData = () => {
    clearInterval();
    this.setState({
      openAddDataDialog: true,
    });
  };

  onToolBarCloseButtonClicked = () => {
    history.goBack();
  };

  getGraphTitle = () => {
    return "";
  };

  getPersonalidedGraphTitle = () => {
    return "";
  };
  renderLoadingAwait = () => {
    return (
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          height: 500,
        }}
      >
        <CircularProgress color="secondary" />
      </div>
    );
  };

  // <VictoryBarGraphs
  //   data={this.state.mBarPreuseData}
  //   company={this.state.company}
  // />

  renderStatisticTable = () => {
    return (
      <div
        style={{
          width: "100%",
          height: 500,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BarGraphComponentV2
          data={this.state.mBarDataPartA}
          legendAxisLeft={""}
          legendAxisBelow={"Questions"}
          indexBy={"Question"}
          keys={["GO", "NO_GO", "GO_BUT"]}
          colors={[
            "hsl(131, 86%, 39%)",
            "hsl(2, 95%, 51%)",
            "hsl(54, 100%, 50%)",
          ]}
        />
      </div>
    );
  };

  renderUtilisationCharts = (machineItem: any) => {
    let mUtilisationData = {
      id: "Utilisation",
      color: "orange",
      priority: 4,
      data: machineItem.utilisationData,
    };
    let mAvailabilityData = {
      id: "Availability",
      color: "blue",
      priority: 3,
      data: machineItem.availabilityData,
    };

    let mQualityData = {
      id: "Quality",
      color: "red",
      priority: 2,
      data: machineItem.qualityData,
    };

    let mOEEData = {
      id: "OEE",
      color: "brown",
      priority: 1,
      data: machineItem.OEEData,
    };

    mUtilisationData.data.sort(
      (a: any, b: any) =>
        moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
    );
    mAvailabilityData.data.sort(
      (a: any, b: any) =>
        moment(a.x, "DD/MM/YYYY").unix() - moment(b.x, "DD/MM/YYYY").unix()
    );
    let colorSeries = new Array<any>();
    let graphsData = new Array<any>();
    if (this.state.checkedUtilisation) {
      graphsData.push(mUtilisationData);
      colorSeries.push(mUtilisationData.color);
    }
    if (this.state.checkedAvailability) {
      graphsData.push(mAvailabilityData);
      colorSeries.push(mAvailabilityData.color);
    }

    if (this.state.checkedOEE) {
      graphsData.push(mOEEData);
      colorSeries.push(mOEEData.color);
    }
    if (this.state.checkedQuality) {
      graphsData.push(mQualityData);
      colorSeries.push(mQualityData.color);
    }
    graphsData.sort((a: any, b: any) => (a.priority < b.priority ? 1 : -1));
    if (
      !this.state.checkedAvailability &&
      !this.state.checkedOEE &&
      !this.state.checkedUtilisation &&
      !this.state.checkedQuality
    ) {
      return (
        <div
          style={{
            height: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          }}
        >
          <img
            src={emptyTrash}
            style={{ width: 40, height: 40 }}
            alt="Empty Trash"
          />
          <Typography
            variant="h5"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`Nothing selected`.toUpperCase()}
          </Typography>
        </div>
      );
    }
    if (mUtilisationData.data.length > 0 || mAvailabilityData.data.length > 0) {
      return (
        <LHDLineGraphComponent
          data={graphsData}
          xLabel={"Utilisation(%)"}
          yLabel={"Availability(%)"}
          colorSeries={colorSeries}
        />
      );
    } else {
      return <div>sdgsd</div>;
    }
  };
  renderMachineEffectivenessCharts = (hasData: any) => {
    let result = this.state.mMachineEffectivenessData[0];
    let mPerfomanceData = {
      id: "Perfomance",
      color: "green",
      priority: 4,
      data: result.perfomanceData,
    };
    let mAvailabilityData = {
      id: "Availability",
      color: "blue",
      priority: 3,
      data: result.availabilityData,
    };

    let mOEEData = {
      id: "OEE",
      color: "orange",
      priority: 1,
      data: result.OEEData,
    };
    let mQualityData = {
      id: "Quality",
      color: "brown",
      priority: 2,
      data: result.qualityData,
    };

    mPerfomanceData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));
    mAvailabilityData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));
    mQualityData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));
    mOEEData.data.sort((a: any, b: any) => (a.x > b.x ? 1 : -1));

    let graphsData = new Array<any>();
    graphsData.push(mPerfomanceData);
    graphsData.push(mAvailabilityData);
    graphsData.push(mOEEData);
    graphsData.push(mQualityData);
    graphsData.sort((a: any, b: any) => (a.priority < b.priority ? 1 : -1));
    if (hasData) {
      return (
        <LHDLineGraphComponent
          data={graphsData}
          xLabel={"Utilisation(%)"}
          yLabel={"Availability(%)"}
          colorSeries={["green", "blue", "orange", "brown"]}
        />
      );
    } else {
      return (
        <div
          style={{
            height: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "auto",
          }}
        >
          <img
            src={emptyTrash}
            style={{ width: 40, height: 40 }}
            alt="Empty Trash"
          />
          <Typography
            variant="h5"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`No data available for`.toUpperCase()}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`${getMomentDate(
              this.state.filterComparisonDate.toDateString(),
              "DD/MM/YYYY"
            )}`}
          </Typography>
          <Typography
            variant={"body1"}
            gutterBottom
            style={{ marginTop: 10, textAlign: "center" }}
          >
            {`Select another date`}
          </Typography>
        </div>
      );
    }
  };
  handleEquipmentSelected = (value: any) => {
    let dataConvertAsync: DataConvertAsync = new DataConvertAsync();
    dataConvertAsync
      .convertToGenericBarData(this.state.genericData, value)
      .then((resp: any) => {
        this.setState(
          {
            mBarDataPartA: resp,
            selectedEquipment: value,
            selectedInspection: "",
            preuseShiftIsNotEmpty: false,
          },
          () => {
            this.getInspectionsByTypeCategoryAndEquipment();
          }
        );
      });
  };
  handleSelectedInspection = (value: any) => {
    let dataConvertAsync: DataConvertAsync = new DataConvertAsync();
    dataConvertAsync
      .convertToGenericBarDataByInspection(this.state.inspections, value)
      .then((resp: any) => {
        this.setState({
          mBarDataPartA: resp,
          selectedInspection: value,
        });
      });
  };
  handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ tabValue: newValue }, () => {
      this.drawBarGraphs();
    });
  };

  handleRadioPreuseButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      { radioPreuseValue: (event.target as HTMLInputElement).value },
      () => {
        this.drawBarGraphs();
      }
    );
  };
  handleRadioOEEButtonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      { radioOEEValue: (event.target as HTMLInputElement).value },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleRadioUtilityButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      {
        radioUtilityValue: (event.target as HTMLInputElement).value,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleRadioEffectivenessButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.setState(
      {
        radioEffectivenessValue: (event.target as HTMLInputElement).value,
      },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      { ...this.state, [event.target.name]: event.target.checked },
      () => {
        this.drawBarGraphs();
      }
    );
  };

  renderFilterContainer = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginTop: -25,
          justifyContent: "center",
          flexDirection: "row",
          zIndex: 1,
        }}
      >
        <Paper
          elevation={3}
          style={{
            margin: 10,
            borderRadius: 12,
            alignSelf: "center",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Autocomplete
            id="combo-box-demo"
            options={this.state.employees}
            getOptionLabel={(employee) => employee.fullName}
            value={
              this.state.employeeFiltered.fullName
                ? this.state.employeeFiltered
                : null
            }
            style={{ width: 300 }}
            onChange={(event: any, value: any) => {
              if (!value) {
                this.setState(
                  {
                    employeeFiltered: { _id: "", fullName: "" },
                    genericData: this.state.originalList,
                  },
                  () => {
                    this.drawGraphs();
                    this.drawBarGraphs();
                  }
                );
              } else {
                this.applyEmployeeFilter(value);
              }
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                id="standard-full-width"
                label="Filter Employee"
                style={{ paddingRight: 20, margin: 10 }}
                onChange={this.handleOnTextChanged}
                placeholder="Search..."
                fullWidth
                margin="normal"
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
              />
            )}
          />
        </Paper>
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="flex-start" style={{ margin: 10 }}>
              <Paper
                elevation={3}
                style={{
                  margin: 10,
                  borderRadius: 12,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <KeyboardDatePicker
                  style={{ margin: 10 }}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="From"
                  autoOk
                  value={this.state.filterStartDate}
                  onChange={this.handleFilterStartDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Paper>
              <Paper
                elevation={3}
                style={{
                  margin: 10,
                  borderRadius: 12,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <KeyboardDatePicker
                  style={{ margin: 10 }}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="To"
                  minDate={this.state.filterStartDate}
                  autoOk
                  value={this.state.filterEndDate}
                  onChange={this.handleFilterEndDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Paper>
            </Grid>
          </MuiPickersUtilsProvider>
        </div>
        <Paper
          elevation={3}
          style={{
            borderRadius: 12,
            height: 60,
            padding: 5,
            alignSelf: "center",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            backgroundColor: this.state.isFiltering ? "#11b92d" : "white",
            flexDirection: "column",
          }}
        >
          {this.state.isFiltering ? (
            <Button
              onClick={() => this.handleApplyFilter()}
              style={{ borderColor: "#11b92d", color: "white" }}
              variant="outlined"
              startIcon={<FilterListIcon style={{ color: "white" }} />}
            >
              Filter
            </Button>
          ) : (
            <Button
              onClick={() => this.handleApplyFilter()}
              style={{ borderColor: "white", color: "grey" }}
              variant="outlined"
              startIcon={<FilterListIcon />}
            >
              Filter
            </Button>
          )}
        </Paper>
      </div>
    );
  };

  renderMachineEffectivenessFilter = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginTop: -25,
          justifyContent: "flex-end",
          flexDirection: "row",
          zIndex: 1,
        }}
      >
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="flex-start" style={{ margin: 10 }}>
              <Paper
                elevation={3}
                style={{
                  margin: 10,
                  borderRadius: 12,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <KeyboardDatePicker
                  style={{ margin: 10 }}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="Comparison Date"
                  autoOk
                  value={this.state.filterComparisonDate}
                  onChange={this.handleFilterComparisonDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Paper>
            </Grid>
          </MuiPickersUtilsProvider>
        </div>
      </div>
    );
  };

  renderTabForPreuseCharts = () => {
    const { classes, properties } = this.props;
    const { inspectionType } = properties;
    return (
      <div>
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              alignItems: "center",
              height: 100,
              justifyContent: "space-between",
              paddingLeft: "2%",
              paddingRight: "2%",
            }}
          >
            {inspectionType &&
              inspectionType.value !== "COVID-19-SCREENING" &&
              inspectionType.value !== "PERSONAL" && (
                <FormControl
                  variant="outlined"
                  style={{ flex: 0.3 }}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="outlined-age-native-simple">
                    Equipment
                  </InputLabel>
                  <Select
                    value={
                      this.state.selectedEquipment
                        ? this.state.selectedEquipment
                        : ""
                    }
                    onChange={(event: any) => {
                      if (event && event.target && event.target.value) {
                        this.handleEquipmentSelected(
                          event.target.value as string
                        );
                      }
                    }}
                    label="Equipments"
                    inputProps={{
                      name: "Equipments",
                      id: "outlined-age-native-simple",
                    }}
                  >
                    {this.state.uniqueNames.map((obj: any, index: any) => {
                      return (
                        <MenuItem
                          key={`machin-item-${index}`}
                          value={obj.label}
                        >
                          {obj.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
            {this.state.uniqueInspectionNames &&
              this.state.uniqueInspectionNames.length > 0 && (
                <FormControl
                  variant="outlined"
                  style={{ flex: 0.3 }}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="outlined-age-native-simple">
                    Inspection name
                  </InputLabel>
                  <Select
                    value={
                      this.state.selectedInspection
                        ? this.state.selectedInspection
                        : ""
                    }
                    onChange={(event: any) => {
                      if (event && event.target && event.target.value) {
                        this.handleSelectedInspection(
                          event.target.value as string
                        );
                      }
                    }}
                    label="Equipments"
                    inputProps={{
                      name: "Equipments",
                      id: "outlined-age-native-simple",
                    }}
                  >
                    {this.state.uniqueInspectionNames.map(
                      (obj: any, index: any) => {
                        return (
                          <MenuItem
                            key={`machin-item-${index}`}
                            value={obj.name}
                          >
                            {obj.name}
                          </MenuItem>
                        );
                      }
                    )}
                    ;
                  </Select>
                </FormControl>
              )}
          </div>
          <Divider />
          <ListItemText
            style={{
              padding: "1%",
            }}
            primaryTypographyProps={{
              style: { fontWeight: "bold" },
            }}
            primary={properties.inspectionType.label}
            secondary={properties.category.label}
          />
          <Divider />
          {this.state.mBarDataPartA && this.state.mBarDataPartA.length > 0 ? (
            this.renderStatisticTable()
          ) : (
            <div
              style={{
                height: 500,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                overflow: "auto",
              }}
            >
              <img
                src={emptyTrash}
                style={{ width: 40, height: 40 }}
                alt="Empty Trash"
              />
              <Typography
                variant="h5"
                gutterBottom
                style={{ marginTop: 10, textAlign: "center" }}
              >
                {"No data available".toUpperCase()}
              </Typography>
            </div>
          )}
        </div>
      </div>
    );
  };
  render() {
    const { classes, profileData } = this.props;
    return (
      <AuthConsumer>
        {({ user, accessRules }) => {
          return (
            <div className={classes.root}>
              <CssBaseline />
              <ThemeProvider theme={defaultTheme}>
                <AppBar
                  position="fixed"
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: this.state.open,
                  })}
                >
                  <Toolbar>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            alignItems: "flex-start",
                            textAlign: "start",
                            flex: 1,
                          }}
                        >
                          <Typography variant="h6" noWrap>
                            Main Dashboard
                          </Typography>
                        </div>

                        <div
                          style={{
                            flex: 0.5,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <HasPermission
                            role={user.role}
                            accessRules={accessRules}
                            perform="dashboard:create"
                            yes={() => (
                              <div style={{ visibility: "hidden" }}>
                                <Button
                                  type="submit"
                                  onClick={() => this.openAddData()}
                                  color="inherit"
                                >
                                  <AddIcon
                                    style={{ margin: 10 }}
                                    className={classes.extendedIcon}
                                  />
                                  Add Data
                                </Button>
                              </div>
                            )}
                            no={() => {
                              return null;
                            }}
                          ></HasPermission>

                          {profileData &&
                          profileData.role &&
                          profileData.role === ROLES.DASHBOARD ? (
                            <Button
                              type="submit"
                              onClick={() => this.onToolBarButtonClicked()}
                              color="inherit"
                            >
                              <LockOpenIcon
                                style={{ margin: 10 }}
                                className={classes.extendedIcon}
                              />
                              Logout
                            </Button>
                          ) : (
                            <Button
                              type="submit"
                              onClick={() => this.onToolBarCloseButtonClicked()}
                              color="inherit"
                            >
                              <CloseIcon
                                style={{ margin: 10 }}
                                className={classes.extendedIcon}
                              />
                              Close
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Toolbar>
                </AppBar>
              </ThemeProvider>
              <div className={classes.content}>
                <div className={classes.toolbar} />
                {this.state.tabValue <= 1
                  ? this.renderFilterContainer()
                  : this.renderMachineEffectivenessFilter()}
                <div
                  style={{
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  {this.renderTabForPreuseCharts()}
                </div>
              </div>
              <LoadingComponents isLoading={this.state.isLoading} />
            </div>
          );
        }}
      </AuthConsumer>
    );
  }
}
export default withStyles(styles)(GenericDashboard);
